import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Card, CardBody } from "reactstrap";
import Box from "@mui/material/Box";

import ContractsList from "../components/ContractsList";
import Avatar from "../components/Avatar";

function User() {
	const { userId } = useParams();
	const selectedUser = useSelector((state) =>
		state.admin.users.find((user) => user._id === userId)
	);

	const renderUserImg = () => {
		if (selectedUser !== null && selectedUser.image) {
			return (
				<img
					height="110"
					width="110"
					alt="user-avatar"
					src={`${process.env.REACT_APP_API_DO_URL}/${selectedUser.image}`}
					className="img-fluid rounded mt-3 mb-2"
				/>
			);
		} else {
			const stateNum = Math.floor(Math.random() * 6),
				states = [
					"light-success",
					"light-danger",
					"light-warning",
					"light-info",
					"light-primary",
					"light-secondary",
				],
				color = states[stateNum];
			return (
				<Avatar
					initials
					color={color}
					className="rounded mt-3 mb-2"
					content={selectedUser.name || "Anonymous"}
					contentStyles={{
						borderRadius: 6,
						fontSize: "calc(48px)",
						width: "100%",
						height: "100%",
					}}
					style={{
						height: "110px",
						width: "110px",
					}}
				/>
			);
		}
	};

	if (!selectedUser) {
		return <h1>Loading</h1>;
	}

	return (
		<Box
			sx={{ minHeight: "78vh", margin: "0 auto", width: "100%" }}
			maxWidth="md"
		>
			<Card className="mb-3">
				<CardBody className="d-flex justify-content-between">
					<div className="user-avatar-section col-3">
						<div className="d-flex align-items-center flex-column">
							{renderUserImg()}
						</div>
					</div>
					<div className="info-container col-9">
						<h4 className="fw-bolder border-bottom pb-50 mb-1">Details</h4>
						<table className="mt-2 mt-xl-0 w-100">
							<tbody>
								<tr>
									<th>Name</th>
									<td>{selectedUser.name || "No info"}</td>
								</tr>
								<tr>
									<th>Address</th>
									<td>{selectedUser.account}</td>
								</tr>
								<tr>
									<th>Description</th>
									<td>{selectedUser.bio || "No info"}</td>
								</tr>
								<tr>
									<th>URL</th>
									<td>{selectedUser.customURL || "No info"}</td>
								</tr>
								<tr>
									<th>Email</th>
									<td>{selectedUser.email || "No info"}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</CardBody>
			</Card>
			<ContractsList userId={userId} />
		</Box>
	);
}

export default User;
